export default "__VITE_PUBLIC_ASSET__2537cafe__"